import manager from './manager.module'
export default manager
